export default {
  apiVersion: {
    admin: 'v1.21-admin',
    public: 'v1.21-public'
  },
  statusColor: {
    cancelled: 'rejected',
    cancelledDueMissingCheckIn: 'rejected',
    checkedOut: 'waiting',
    checkedIn: 'available',
    booked: 'pending',
  },
  typeRequest: [
    { value: 'cleaning', label: 'cleaning' },
    { value: 'electrical', label: 'electrical' },
    { value: 'furniture', label: 'furniture' },
    { value: 'it', label: 'it' },
    { value: 'temperature', label: 'temperature' },
    { value: 'catering', label: 'catering' },
    { value: 'others', label: 'others' },
  ],
  behaviorRequest: [
    { value: 'default', label: 'email' },
    { value: 'whatsApp', label: 'whatsApp' }
  ],
  deskTypeFilterOptions: [
    { value: false, label: 'allDesks' },
    { value: true, label: 'desksWithBookings' }
  ],
  uploadStatus: {
    waiting: 'WAITING',
    uploading: 'UPLOADING',
    success: 'SUCCESS',
    error: 'ERROR',
  },
  bookingType: {
    forGuest: 'forGuest'
  },
  pinStatus: {
    removed: 'removed',
    updated: 'updated',
    inserted: 'inserted',
    none: 'none'
  },
  bookingParams: {
    defaultStartTime: '08:00',
    limitTime: '18:00',
    limitBookingEndTime: '23:00'
  },
  restaurantBookingParams: {
    maxSlots: '30'
  },
  userBookingComponent: {
    desk: 'DeskBookingCard',
    locker: 'LockerBookingCard',
    restaurant: 'RestaurantBookingCard',
    charteredBus: 'CharteredBookingCard',
    parking: 'ParkingBookingCard'
  },
  tabFields: [
    {
      key: 'tab-restaurant',
      value: [
        'periodForRestaurantBooking',
        'restaurantAvailableFrom',
        'amountOfSlotsForRestaurant'
      ]
    },
    {
      key: 'tab-corporate-notice',
      value: ['corporateNoticeAdvice']
    },
    {
      key: 'tab-booking',
      value: [
        'antecedence-limit',
        'minimum-booking-limit',
        'maximum-booking-limit',
        'customDays',
        'checkinTolerance'
      ]
    },
    {
      key: 'tab-desk',
      value: [
        'limitAmountOfBookings',
        'maximum-days-restaurant-booking-limit',
        'maximum-hours-restaurant-booking-limit'
      ]
    },
    {
      key: 'tab-parking',
      value: [
        'maximum-days-parking-booking-limit',
        'maximum-hours-parking-booking-limit'
      ]
    }
  ],
  downloadFile: {
    statusProcessed: 200,
    maxTimeToWait: 180000,
    initialRetry: 0,
    initialSumTimeToWait: 2000
  },
  checkinTypes: {
    beacon: 'beacon',
    qrCode: 'qrCode',
    qrCodeAndBeacon: 'qrCodeAndBeacon'
  },
  checkInStatus: {
    cancelled: 'cancelled',
    cancelledDueMissingCheckIn: 'cancelledDueMissingCheckIn',
    checkedOut: 'checkedOut',
    checkedIn: 'checkedIn',
    booked: 'booked',
  },
  bookingStatus: {
    desk: [
      { value: 'cancelled', label: 'cancelled' },
      { value: 'cancelledDueMissingCheckIn', label: 'cancelledDueMissingCheckIn' },
      { value: 'checkedOut', label: 'checkedOut' },
      { value: 'checkedIn', label: 'checkedIn' },
      { value: 'booked', label: 'booked' },
    ],
    parking: [
      { value: 'cancelled', label: 'cancelled' },
      { value: 'checkedOut', label: 'checkedOut' },
      { value: 'checkedIn', label: 'checkedIn' },
      { value: 'booked', label: 'booked' },
      { value: 'cancelledDueMissingCheckIn', label: 'cancelledDueMissingCheckIn' },
    ],
    charteredBus: [
      { value: 'cancelled', label: 'cancelled' },
      { value: 'booked', label: 'booked' },
    ],
    restaurant: [
      { value: 'cancelled', label: 'cancelled' },
      { value: 'booked', label: 'booked' },
      { value: 'checkedIn', label: 'checkedIn' },
    ],
    locker: [
      { value: 'cancelled', label: 'cancelled' },
      { value: 'cancelledDueMissingCheckIn', label: 'cancelledDueMissingCheckIn' },
      { value: 'checkedOut', label: 'checkedOut' },
      { value: 'checkedIn', label: 'checkedIn' },
      { value: 'booked', label: 'booked' },
    ]
  },
  itineraryOptions: [
    { value: 'round', label: 'roundTrip' },
    { value: 'oneWay', label: 'oneWayTrip' },
    { value: 'return', label: 'returnTrip' },
  ],
  bookingLimitPeriodInDays: {
    weekly: 7,
    monthly: 31,
  },
  charteredBusBookingTripType: {
    none: 'none',
    round: 'round',
    custom: 'custom',
    oneWay: 'oneWay',
    return: 'return'
  },
  charteredTripTypeKey: {
    round: 'roundTrip',
    oneWay: 'oneWayTrip',
    return: 'returnTrip'
  },
  charteredComponentKey: {
    round: 'chartered-round-trip',
    oneWay: 'chartered-one-way-trip',
    return: 'chartered-return-trip'
  },
  filterOptionsBoookings: [
    {
      id: 0,
      name: 'desk'
    },
    {
      id: 1,
      name: 'restaurant'
    },
    {
      id: 2,
      name: 'charteredBus'
    },
    {
      id: 3,
      name: 'parking'
    },
    {
      id: 4,
      name: 'locker'
    }
  ],
  bookingTypeEnum: {
    'desk': 0,
    'restaurant': 1,
    'charteredBus': 2,
    'parking': 3,
    'locker': 4
  },
  recurrences: {
    notRepeat: 'notRepeat',
    daily: 'daily',
    weekly: 'weekly',
    none: 'none'
  },
  typeOptions: [
    {
      id: "notRepeat",
      name: "notRepeat"
    },
    {
      id: "daily",
      name: "daily"
    },
    {
      id: "weekly",
      name: "weekly"
    }
  ],
  weekDayOptions: {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday'
  },
  typeParkingIntegration: [
    {
      type: 'iDSecure',
      name: 'iDSecure'
    }
  ],
  typeRestaurantIntegration: [
    {
      type: 'invenzi',
      name: 'Invenzi (W-Access)'
    }
  ],
  maxSearchTeam: 60,
  minSearchTeam: 30,
  bookingLimitPeriod: {
    'withoutLimit': 1,
    'weekly': 2,
    'monthly': 3
  }
}
